import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import Editor from './Editor';

function Education({ education, syncErrors, syncing, onSave, onDelete }) {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleClose = useCallback(() => navigate('/resume'), [navigate]);

  return (
    <Editor
      education={education}
      id={id}
      syncErrors={syncErrors}
      syncing={syncing}
      onClose={handleClose}
      onDelete={onDelete}
      onSave={onSave}
    />
  );
}

Education.propTypes = {
  education: PropTypes.array,
  syncErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  syncing: PropTypes.bool,
  onSave: PropTypes.func,
  onDelete: PropTypes.func
};

export default Education;
